export const OFFER_URL = 'api/v4/coupons/';
export const PERCENT_AMOUNT_TYPE = 'PERCENT_AMOUNT';
export const CATEGORY_PERCENT_AMOUNT_TYPE = 'CATEGORY_PERCENT_AMOUNT';
export const DOLLAR_AMOUNT_TYPE = 'DOLLAR_AMOUNT';
export const MARKETING_CODE_TYPE = 'CouponCategory.MARKETING';
export const REACTIVATION_CODE_TYPE = 'REACTIVATION';
